import { resolveDynamicComponent as _resolveDynamicComponent, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: /*#__PURE__*/_normalizeClass([
  'fixed top-0',
  'w-full h-full',
  'bg-white'
  ])
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_router_view = _resolveComponent("router-view")
  const _component_LayoutHeader = _resolveComponent("LayoutHeader")

  return ($data.payload.length === $data.institutions.length)
    ? (_openBlock(), _createElementBlock("main", _hoisted_1, [
        _createVNode(_component_router_view, null, {
          default: _withCtx(({ Component }) => [
            _createVNode(_Transition, {
              css: true,
              mode: "out-in",
              name: "fade"
            }, {
              default: _withCtx(() => [
                (_openBlock(), _createBlock(_resolveDynamicComponent(Component), {
                  class: _normalizeClass([
          'absolute top-0 left-0',
          'w-full h-full'
        ])
                }))
              ]),
              _: 2
            }, 1024)
          ]),
          _: 1
        }),
        _createVNode(_component_LayoutHeader, { class: "" })
      ]))
    : _createCommentVNode("", true)
}